<forge-card no-padding>
    <forge-toolbar fxLayout="column">
        <h2 slot="start" class="forge-typography--heading4">Quick Links</h2>
    </forge-toolbar>

    <div class="metadata-padding">
        @if (!isLoaded) {
        <busy-indicator [chart]="true"></busy-indicator>
        }

        @else {
        @for (row of rows; track row) {
        <div class="row">
            @for (link of row; track link) {
            <div fxFlex="50">
                <a (click)="onLinkClicked(link.Link)" [attr.telemetry]="getAriaLabel(link)"
                    [attr.aria-label]="getAriaLabel(link)" tabindex="0">
                    {{link.Name}}
                </a>
            </div>
            }
        </div>
        }

        @if (!chartHasData)
        {
        <div>There are no quick links</div>
        }
        }
    </div>
</forge-card>